(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('package-feature-list', {
                parent: 'entity',
                url: '/package-feature-list?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.packageFeatureList.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/package-feature-list/package-feature-lists.html',
                        controller: 'PackageFeatureListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('packageFeatureList');
                        $translatePartialLoader.addPart('featureStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('package-feature-list-detail', {
                parent: 'entity',
                url: '/package-feature-list/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.packageFeatureList.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/package-feature-list/package-feature-list-detail.html',
                        controller: 'PackageFeatureListDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('packageFeatureList');
                        $translatePartialLoader.addPart('featureStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PackageFeatureList', function ($stateParams, PackageFeatureList) {
                        return PackageFeatureList.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('package-feature-list.new', {
                parent: 'package-feature-list',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/package-feature-list/package-feature-list-dialog.html',
                        controller: 'PackageFeatureListDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    sendingSMS: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('package-feature-list', null, {reload: true});
                    }, function () {
                        $state.go('package-feature-list');
                    });
                }]
            })
            .state('package-feature-list.edit', {
                parent: 'package-feature-list',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/package-feature-list/package-feature-list-dialog.html',
                        controller: 'PackageFeatureListDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['PackageFeatureList', function (PackageFeatureList) {
                                return PackageFeatureList.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('package-feature-list', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('package-feature-list.delete', {
                parent: 'package-feature-list',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/package-feature-list/package-feature-list-delete-dialog.html',
                        controller: 'PackageFeatureListDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['PackageFeatureList', function (PackageFeatureList) {
                                return PackageFeatureList.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('package-feature-list', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
